import { render, staticRenderFns } from "./link-footer.vue?vue&type=template&id=3b935500&"
import script from "./link-footer.vue?vue&type=script&lang=js&"
export * from "./link-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports